// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"b194f72fdcd3176a","2013":"f702c3594d66d0b6","3807":"0a2b6f0693957915","9099":"320428ae2ad86c47"}[chunkId] + ".js";
};